/**
 * Kalici mesaj alanlarini TEK render metnine birlestirir.
 *
 * ## Neden ortak bir yardimci
 *
 * Sunucu `think_text` ve `tool_cards`i AYRI kolonlarda tutuyor (prompt
 * kurarken dislamak trivial olsun diye) ama render hatti tek bir metin
 * bekliyor. Bu ceviriyi yapan kod uc yerde gerekiyor: gecmis mesajlar, canli
 * akis ve paylasilan gorunum.
 *
 * Uc kopya tutmak kacinilmaz olarak AYRISIR - ve ayristigi gun paylasilan
 * gorunum sohbetten farkli gorunmeye baslar, ki bu tam olarak fark edilmesi
 * en zor hata turu (her ikisi de "calisiyor" gorunur).
 *
 * Sira canli akistakiyle AYNI olmak zorunda: dusunme once, sonra icerik -
 * ve kartlar METNIN ICINDE, gercekten calistiklari yerde.
 *
 * ## Kart konumlari
 *
 * Sunucu `content` icine `[[TOOLCARD:0]]` bicimli kisa bir KONUM ISARETI
 * yaziyor (bkz. `runs/executor.py`); kartin payload'i `tool_cards` kolonunda
 * duruyor. Burada isaret, ilgili kartin tam sentinel'iyle degistiriliyor.
 *
 * Onceki hal kartlari metnin SONUNA diziyordu ve canli akistan AYRISIYORDU:
 * kullanici yenileme/paylasim sonrasi once butun anlatimi tek blok, sonra
 * kartlari arka arkaya goruyordu. 18 kartli bir yanitta bu okunmaz hale
 * geliyordu (olculen vaka `oBhJv-VLIUIdDPX45VpgLw`).
 *
 * ISARETSIZ eski mesajlar icin davranis DEGISMIYOR: kartlar sona ekleniyor.
 */

export interface RenderableMessage {
  content: string
  think_text: string | null
  tool_cards: Record<string, unknown>[]
}

const MARK_RE = /\[\[TOOLCARD:(\d+)\]\]/g

function sentinel(card: Record<string, unknown>): string {
  // Render hatti (`segments.ts`) bu bicimi zaten anliyor.
  return `\n\n[[TOOLCARD]]${JSON.stringify(card)}[[/TOOLCARD]]\n\n`
}

export function composeMessageText(message: RenderableMessage): string {
  const chunks: string[] = []
  if (message.think_text) {
    chunks.push(`<think>${message.think_text}</think>`)
  }
  const cards = message.tool_cards ?? []
  const used = new Set<number>()
  const body = (message.content ?? '').replace(MARK_RE, (_whole, raw: string) => {
    const index = Number(raw)
    const card = cards[index]
    if (!card) return ''
    used.add(index)
    return sentinel(card)
  })
  chunks.push(body)
  // Isaretlenmemis kartlar (isaret oncesi kaydedilmis eski mesajlar, ya da
  // beklenmedik bir uyusmazlik) KAYBOLMUYOR: sona ekleniyorlar.
  cards.forEach((card, index) => {
    if (!used.has(index)) chunks.push(sentinel(card))
  })
  return chunks.join('')
}
